import { get, post, patch, remove } from '@/helpers/httpHandler';

export default {
  retrieveServices: () => get('/services'),

  retrieveEmployeeServices: () => get('/employee-services'),

  retrieveServicesCCustomer: () => get('/customer-services-list/category/1'),

  retrieveServicesBCustomer: () => get('/customer-services-list/category/2'),

  retrieveInternalServicesList: () => get('/internal-services-list'),

  retrieveService: (_, service) => get(`/services/${service}`),

  store: (_, service) => post('/services', service),

  update: (_, data) => patch(`/services/${data.service.id}`, data),

  remove: (_, data) => remove(`/services/${data.service}`),

  retrieveServicesTypes: () => get('/services-types'),

  retrieveCustomerCategories: () => get('/services-customer-categories'),

  storeCustomerService: ({ commit }, service) => {
    return post('/customer-services', service).then(response => {
      commit('addService', response);
      return response;
    });
  },

  storeInternalService: ({ commit }, service) => {
    return post('/internal-services', service).then(response => {
      commit('addService', response);
      return response;
    });
  },

  retrieveCustomerService: (_, id) => get(`/customer-services/${id}`),
  retrieveInternalService: (_, id) => get(`/internal-services/${id}`),
  cloneService: (_, id) => post(`/services/clone/${id}`),

  updateCustomerService: ({ commit }, payload) => {
    return patch(`/customer-services/${payload.id}`, payload.data).then(
      response => {
        commit('updateService', response);
        return response;
      }
    );
  },

  updateInternalService: ({ commit }, payload) => {
    return patch(`/internal-services/${payload.id}`, payload.data).then(
      response => {
        commit('updateService', response);
        return response;
      }
    );
  },

  retrieveAppsByServiceId: (_, { params }) => {
    return get(`/applications/by-service`, params)
  },

  getGroups: () => get('/services/groups'),

  getAttributes: (_, id) => get(`/customer-services/${id}/attributes`),

  updateAttributes: (_, data) =>
    patch(`/customer-services/${data.id}/attributes`, data)
};
